<template>
	<div>
		<div class="b1 bc7 p4 bg5 r2">
			<template v-if="component_">
				<component
					v-if="plan_"
					:is="component_"
					@premium:updated="$emit('premium:updated')"
					v-bind="{
						productId,
						caseId: $store.state.caseManagement.caseId,
						proposalId: $store.state.caseManagement.proposalId,
						offerId: $store.state.caseManagement.offerId
					}"
				/>
			</template>
		</div>
	</div>
</template>
<script>
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// import SelectProduct from "../SelectProduct.vue"
import PricingJewellersBlockPrimaryLayer from "./JB/PricingJewellersBlockPrimaryLayer"
import PricingJewellersBlockExcessLayer from "./JB/PricingJewellersBlockExcessLayer"
import PricingJewellersBlockOpenMarket from "./JB/PricingJewellersBlockOpenMarket"
import PricingEmployeesCompensationPrimaryLayer from "./EC/PricingEmployeesCompensationPrimaryLayer"
import PricingPersonalJewelleryPrimaryLayer from "./PJ/PricingPersonalJewelleryPrimaryLayer"
import PricingCommercialBlockPrimaryLayer from "./CB/PricingCommercialBlockPrimaryLayer"
import PricingJewellersExhibitionPrimaryLayer from "./EX/PricingJewellersExhibitionPrimaryLayer"
import PricingJewellersExhibitionExcessLayer from "./EX/PricingJewellersExhibitionExcessLayer"
import PricingPublicLiabilityPrimaryLayer from "./MS/PricingPublicLiabilityPrimaryLayer"
import PricingJewellersTourPrimaryLayer from "./TO/PricingJewellersTourPrimaryLayer"
import PricingSendingInsurancePrimaryLayer from "./SH/PricingSendingInsurancePrimaryLayer"

export default {
	components: {
		PricingJewellersBlockPrimaryLayer,
		PricingJewellersBlockExcessLayer,
		PricingJewellersBlockOpenMarket,
		PricingEmployeesCompensationPrimaryLayer,
		PricingPersonalJewelleryPrimaryLayer,
		PricingCommercialBlockPrimaryLayer,
		PricingJewellersExhibitionPrimaryLayer,
		PricingJewellersExhibitionExcessLayer,
		PricingPublicLiabilityPrimaryLayer,
		PricingJewellersTourPrimaryLayer,
		PricingSendingInsurancePrimaryLayer
	},

	props: {
		label: {
			type: String,
			default: "Pricing Calculation"
		},

		productId: {
			validator(val) {
				return val === null || typeof val === "object"
			}
		}
	},

	data() {
		return {
			// Dictionary of pricing components that can be used
			dictionary: {
				jewellers_block_primary_layer_hkd: "PricingJewellersBlockPrimaryLayer",
				jewellers_block_primary_layer_usd: "PricingJewellersBlockPrimaryLayer",
				jewellers_block_excess_layer_hkd: "PricingJewellersBlockExcessLayer",
				jewellers_block_excess_layer_usd: "PricingJewellersBlockExcessLayer",
				jewellers_block_open_market_hkd: "PricingJewellersBlockOpenMarket",
				jewellers_block_open_market_usd: "PricingJewellersBlockOpenMarket",
				employees_compensation: "PricingEmployeesCompensationPrimaryLayer",
				personal_jewellery: "PricingPersonalJewelleryPrimaryLayer",
				commercial_block: "PricingCommercialBlockPrimaryLayer",
				jewellers_exhibition_primary_layer:
					"PricingJewellersExhibitionPrimaryLayer",
				jewellers_exhibition_excess_layer:
					"PricingJewellersExhibitionExcessLayer",
				public_liability_event_and_exhibition:
					"PricingPublicLiabilityPrimaryLayer",
				public_liability_advertising_signs_and_decoration:
					"PricingPublicLiabilityPrimaryLayer",
				jewellers_tour_primary_layer: "PricingJewellersTourPrimaryLayer",
				sending: "PricingSendingInsurancePrimaryLayer"
			}
		}
	},

	computed: {
		plan_() {
			return this.productId?.plan
		},

		component_() {
			return this.dictionary[this.plan_] ? this.dictionary[this.plan_] : null
		}
	},

	methods: {
		async clearOfferValues() {
			const query = gql`
				mutation updateOfferOfProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$updateOfferInput: updateOfferInput!
				) {
					updateOfferOfProposal(
						caseId: $caseId
						offerId: $offerId
						proposalId: $proposalId
						updateOfferInput: $updateOfferInput
					) {
						errors
						errors_2 {
							code
							message
						}
						status
					}
				}
			`
			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				updateOfferInput: { values: null }
			}

			const res = await api({ query, variables })
		}
	},

	watch: {
		// clear values in offer when product is removed from any offer
		productId: function() {
			if (this.productId === null) {
				this.clearOfferValues()
			}
		}
	}
}
</script>
